import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, ReportService, SessionInformationService } from 'app/core/core.module';
import { Guid } from 'app/core/data/entities';
import { HistoryService } from 'app/core/history.service';
import { Confirmation, Dealer } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';

@Component({
    selector: 'app-confirmation-history',
    templateUrl: './confirmation-history.component.html',
    styleUrls: ['./confirmation-history.component.scss'],
    standalone: false
})
export class ConfirmationHistoryComponent implements OnInit {
    uow = inject(GenesisUnitOfWork);
    auth = inject(AuthService);
    sessionInfo = inject(SessionInformationService);
    appInfo = inject(AppInformationService);
    route = inject(ActivatedRoute);
    router = inject(Router);
    historyService = inject(HistoryService);
    reportService = inject(ReportService);

    confirmations: any[];
    filter: any;
    dealers: Dealer[];

    onExporting = SharedModule.onExporting;

    async ngOnInit() {
        this.dealers = await this.uow.getDealers();
        const filter = this.sessionInfo.getItem('confirmation-history-filter');

        this.route.queryParams.subscribe(async (params) => {
            const code = params.code as Guid;
            if (code) {
                this.filter = { code, includeDeleted: false };
                await this.search();
            } else if (filter) {
                this.filter = filter;
                await this.search();
            } else {
                this.filter = { includeDeleted: false };
            }
        });
    }

    async search() {
        this.appInfo.pleaseWaitShow();
        this.sessionInfo.setItem('confirmation-history-filter', this.filter);
        this.confirmations = await this.historyService.getConfirmationHistory(this.filter);
        this.appInfo.pleaseWaitHide();
    }

    clear() {
        this.sessionInfo.removeItem('confirmation-history-filter');
        this.filter = { includeDeleted: false };
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async open(orderId: number) {
        this.router.navigate([`/sales-orders/${orderId}`]);
    }

    async viewConfirmation(code: any) {
        if (!code) return;
        this.router.navigate([`/portal/dealer-confirmation/${code}`]);
    }

    print(confirmation: Confirmation) {
        if (!confirmation) return;
        this.reportService.printConfirmation(confirmation.code);
    }
}
